import React, { useState } from 'react'
import { TextBox } from 'srcReact/components/common2/TextBox'
import Button from 'srcReact/components/common2/Button'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

function PronounPopup({
  handleSubmit,
  closeModal,
  customPronounFirst,
  customPronounSecond,
  setCustomPronounFirst,
  setCustomPronounSecond,
  setOtherPronoun,
}) {
  const { t } = useTranslation()
  const [showErrorPronoun, setShowErrorPronoun] = useState(false)
  const [showErrorPronounType, setShowErrorPronounType] = useState(false)
  const [customPronounFirstPart, setCustomPronounFirstPart] = useState(customPronounFirst)
  const [customPronounSecondPart, setCustomPronounSecondPart] = useState(customPronounSecond)

  const validateNoun = (noun) => /^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/.test(noun)

  const verifyPronoun = () => {
    if (!customPronounFirstPart || !customPronounSecondPart) {
      setShowErrorPronoun(true)
      setShowErrorPronounType(false)
    } else if (!validateNoun(customPronounFirstPart) || !validateNoun(customPronounSecondPart)) {
      setShowErrorPronoun(false)
      setShowErrorPronounType(true)
    } else {
      setOtherPronoun()
      close()
    }
  }
  const close = () => {
    closeModal()
    if (
      !customPronounFirstPart ||
      !customPronounSecondPart ||
      !validateNoun(customPronounFirstPart) ||
      !validateNoun(customPronounSecondPart)
    ) {
      setCustomPronounFirstPart('')
      setCustomPronounSecondPart('')
      setPronounId({})
      setShowErrorPronoun(false)
      setShowErrorPronounType(false)
    }
  }
  return (
    <div className={styles.mainContainerPopin}>
      <a onClick={closeModal} className={styles.closePopin}>
        &times;
      </a>
      <div className={styles.containerPopin}>
        <div className={styles.titlePopin}>{t('signup.profile_edition.popup.pronoun')}</div>
        <div className={styles.containerTextBox}>
          <TextBox
            customInputCss={styles.textBoxPopin}
            fieldInfo={{ value: customPronounFirstPart }}
            placeholder={t('signup.profile_edition.popup.they')}
            onChange={(e) => {
              setCustomPronounFirstPart(e.target.value)
              setCustomPronounFirst(e.target.value)
            }}
            onBlur={() => null}
          />
          <div className={styles.separatorTextBoxPopin}>/</div>
          <TextBox
            customInputCss={styles.textBoxPopin}
            fieldInfo={{ value: customPronounSecondPart }}
            placeholder={t('signup.profile_edition.popup.them')}
            onChange={(e) => {
              setCustomPronounSecondPart(e.target.value)
              setCustomPronounSecond(e.target.value)
            }}
            onBlur={() => null}
          />
        </div>
        {showErrorPronoun && <div className={styles.errorPopin}>{t('signup.profile_edition.popup.empty')}</div>}
        {showErrorPronounType && <div className={styles.errorPopin}>{t('signup.profile_edition.popup.invalids')}</div>}
        <Button
          text={t('signup.profile_edition.confirm')}
          size='large'
          customStyle={styles.buttonPopin}
          handleClick={verifyPronoun}
        />
      </div>
    </div>
  )
}

export default PronounPopup
